// user-dashboard/components/GetNewTmAccountModal.jsx
import React, { useEffect, useState } from "react";
import { requestNewTmAccount } from "../../../api";

const REASONS = [
  { value: "map_issue", label: "Map Issue" },
  { value: "bad_queue_number", label: "Bad Queue Number" },
  {
    value: "too_many_buys_transfers",
    label: "Too Many Buys/Transfers on Account",
  },
  { value: "other", label: "Other – Please state the reason." },
];

export default function GetNewTmAccountModal({ open, onClose, record, onSubmitted }) {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [useSameDetails, setUseSameDetails] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!open) return;
    setReason("");
    setOtherReason("");
    setUseSameDetails(false);
    setSubmitting(false);
    setError("");
    setSuccess(false);
  }, [open, record?.id]);

  if (!open) return null;

  const email = (record?.email || "").trim() || "—";
  const site = (record?.site || "").trim() || "—";
  const canSubmit =
    !!reason &&
    (reason !== "other" || otherReason.trim()) &&
    !submitting;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || !record?.id) return;
    setError("");
    setSubmitting(true);
    try {
      const created = await requestNewTmAccount({
        advice_password_id: record.id,
        reason,
        other_reason: reason === "other" ? otherReason.trim() : null,
        use_same_details: useSameDetails,
      });
      onSubmitted?.(record, created);
      setSuccess(true);
      setTimeout(() => {
        onClose?.();
      }, 1600);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(
        (typeof detail === "string" && detail) ||
          err?.message ||
          "Failed to submit request. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Get New TM Account</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={submitting}
            />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {success && (
                <div className="alert alert-success mb-0">
                  Request submitted. Staff will process it in 1–30 days depending on demand.
                </div>
              )}
              {error && (
                <div className="alert alert-danger py-2">{error}</div>
              )}
              {!success && (
                <>
                  <div className="alert alert-warning py-2 small">
                    Completion time can range from 1–30 days depending on demand.
                  </div>
                  <div className="p-2 rounded mb-3" style={{ background: "#f8f9fa" }}>
                    <div><strong>Email:</strong> {email}</div>
                    <div><strong>Site:</strong> {site}</div>
                  </div>

                  <div className="mb-3">
                    <div className="form-label fw-semibold">
                      Please select the reason you require a new account:
                    </div>
                    {REASONS.map((item) => (
                      <div key={item.value} className="mb-2">
                        <label
                          className="form-check d-flex align-items-start gap-2 mb-0"
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            className="form-check-input mt-1"
                            type="radio"
                            name="tm-account-reason"
                            value={item.value}
                            checked={reason === item.value}
                            onChange={() => setReason(item.value)}
                            disabled={submitting}
                          />
                          <span className="form-check-label">
                            {item.label}
                          </span>
                        </label>
                      </div>
                    ))}
                    {reason === "other" && (
                      <textarea
                        className="form-control mt-2"
                        rows={3}
                        placeholder="Please state the reason"
                        value={otherReason}
                        onChange={(e) => setOtherReason(e.target.value)}
                        disabled={submitting}
                        required
                      />
                    )}
                  </div>

                  <div className="mb-0">
                    <div className="form-label fw-semibold mb-2">Account Details</div>
                    <label
                      className="form-check d-flex align-items-start gap-2 mb-0"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        className="form-check-input mt-1"
                        type="checkbox"
                        checked={useSameDetails}
                        onChange={() => setUseSameDetails((v) => !v)}
                        disabled={submitting}
                      />
                      <span className="form-check-label">
                        Use the same details as my existing
                      </span>
                    </label>
                  </div>
                </>
              )}
            </div>
            {!success && (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                  disabled={submitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!canSubmit}
                >
                  {submitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Submitting...
                    </>
                  ) : (
                    "Submit Request"
                  )}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
